import { type MsalService } from '@azure/msal-angular';
import { type AccountInfo } from '@azure/msal-browser';

// Returns the signed-in account, promoting the first cached account to the
// active account when MSAL hasn't set one yet (e.g. immediately after a redirect,
// before AppComponent runs). All guards must resolve the account the same way,
// otherwise they disagree on who is signed in and bounce between routes.
export function resolveActiveAccount(
    msalService: MsalService
): AccountInfo | null {
    const active = msalService.instance.getActiveAccount();
    if (active) {
        return active;
    }

    const fallback = msalService.instance.getAllAccounts()[0] ?? null;
    if (fallback) {
        msalService.instance.setActiveAccount(fallback);
    }

    return fallback;
}